import React from "react";
import { MdAutoDelete } from "react-icons/md";
import { Tooltip } from "antd";
import { useDispatch } from "react-redux";
import { DeleteDocument } from "../../../Api/SuperAdminVault/Documents";

export default function DocumentDeleteList({
  content,
  title,
  setDeleteModalIsOpen,
  api,
  filter,
}) {
  const dispatch = useDispatch();

  const handleSubmit = () => {
    setDeleteModalIsOpen(false);
    DeleteDocument(api, dispatch, filter);
  };

  return (
    <div>
      <div className="flex flex-col justify-center">
        <div className="items-center flex-col flex justify-center mt-[0.5vw]">
          <MdAutoDelete color="#1f4b7f" size={"5vw"} />

          <p className="text-[1.7vw] font-semibold text-[#1f4b7f] mt-[1vw]">
            Are You Sure ?
          </p>

          <p className="flex justify-center items-center gap-[0.5vw] text-[1.1vw] text-[#1f4b7f] mt-[0.5vw] text-center leading-tight">
            <span>{content}</span>

            {title ? (
              title.length >= 20 ? (
                <Tooltip
                  placement="top"
                  title={title}
                  className="cursor-pointer"
                  color="white"
                  overlayInnerStyle={{
                    color: "#1F487C",
                  }}
                >
                  <span>{`${title.slice(0, 10)}...`}</span>
                </Tooltip>
              ) : (
                <span>{title}</span>
              )
            ) : (
              "-"
            )}
            ?
          </p>
        </div>

        <div className="flex items-center mt-[2vw] gap-[2vw] justify-center">
          <button
            className="border-[#1f4b7f] border-[0.1vw] rounded-[0.5vw] text-[1.1vw] font-semibold text-[#1f4b7f] w-[10vw] h-[3vw]"
            onClick={() => setDeleteModalIsOpen(false)}
          >
            No
          </button>

          <button
            className="bg-[#1f4b7f] text-white font-semibold text-[1.1vw] w-[10vw] h-[3vw] rounded-[0.5vw]"
            onClick={handleSubmit}
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  );
}